import React, { Component } from 'react';
import { Redirect, Route } from 'react-router'
import { Col, Grid, Row, Button } from 'react-bootstrap';
import { MobileView, isMobile } from "react-device-detect";
import MenuPrincipal from './MenuPrincipal';
import MenuFinal from './MenuFinal';
import { LinkContainer } from 'react-router-bootstrap';
import '../css/Global.css';
import Cargando from '../Images/cargando.gif';
import LogoWhatsApp from '../Images/WhatsApp.png';
import EsquelaMaricela from '../Images/Esquela.png';
import Logo from '../Images/Logo.png';

import P2020 from '../video/P2020_1.mp4';
import Modelo from '../video/Modelo_1.mp4';
import P2020M from '../video/P2020.3gp';
import ModeloM from '../video/Modelo.3gp';


export class PopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Datos: [],
            Visible: false,
            Mensaje: 1,
            Alto: (window.innerHeight * .85)
        }

        this.ocultar = this.ocultar.bind(this);
        this.mostrar = this.mostrar.bind(this);
    }

    ocultar() {
        this.setState({Visible: false})
    }
    mostrar(mensaje, texto) {
        this.setState({ Visible: true, Datos: texto, Mensaje: mensaje });
    }



    componentDidMount() {
        var principal = this;
        window.onresize = () => { principal.setState({ Alto: (window.innerHeight * .85) }); };
    }

    reproducir(videoUrl) {

    }

    render() {
        return (

            <div>
                {this.state.Visible ?
                    <div>
                        <div className="LightBox" onClick={this.ocultar}>
                        </div>
                        <div className="LightBoxDiv" style={{ height: this.state.Alto }}>
                            <div className="CerrarX" onClick={this.ocultar}>X</div>
                            {this.state.Mensaje === 1 ?
                                <div>
                                    <p>
                                        Por favor proporcione los siguientes datos:
                                    </p>
                                    <p>
                                        <ul>
                                            {this.state.Datos.map((item, index) => {
                                                return (
                                                <li>
                                                    <p>{item}</p>
                                                </li>
                                            )
                                        })}
                                            </ul>
                                
                                    </p>
                                    <input value="Aceptar" type="button" onClick={this.ocultar} />
                                </div>
                                :
                                null}
                            {this.state.Mensaje === 2 ?
                                <div>
                                    <br/>
                                    <p style={{fontSize: "16pt"}}>
                                        Enviando
                                    </p>
                                        <img src={Cargando} alt="Cargando" style={{ width: "120px", heigth: "40px", top:"-30px" }} />
                                </div>
                                :
                                null}

                            {this.state.Mensaje === 3 ?
                                <div>
                                    <img src={Logo} alt="Logo Icyteg" style={{ width: "55px", margin: "15px" }} />
                                    <br />
                                    <p style={{ fontSize: "14pt" }}>
                                        Muchas gracias por considerar nuestros servicios
                                    </p>
                                    <p style={{ fontSize: "12pt" }}>
                                       <strong> Hemos enviado informaci&oacute;n a tu correo electr&oacute;nico</strong>, en caso de que no te aparezca,  por favor revisa la carpeta de <strong>correo no deseado (SPAM)</strong>
                                    </p>
                                    <p style={{ fontSize: "12pt" }}>
                                        Tu solicitud ha sido asignada a un ejecutivo de admisiones el cual en breve te contactar&aacute; para brindarte toda la informaci&oacute;n que necesites.</p>
                                    <p>Te proporcionamos sus datos por si requieres contactarlo:
                                    </p>
                                    <ul style={{width: "390px", margin:"auto"}}>
                                        <li>
                                            <strong>Ejecutivo:</strong> Jazmín Guadalupe Ayala
                                        </li>
                                        <li>
                                            <strong>Tel&eacute;fono:</strong> (462)6271789 
                                            </li>
                                        <li>
                                            <strong>WhatsApp:</strong> +52 (462) 3403369
                                            <MobileView>
                                                <p>
                                                    <a href='https://wa.me/524623403369' target="_blank"><img src={LogoWhatsApp} alt='llamar WhatsApp' style={{ width: "30px" }} /> Enviar mensaje ahora</a>
                                                </p>
                                            </MobileView>
                                        </li>
                                    </ul>


                                </div>
                                :
                                null}

                            {this.state.Mensaje === 4 ?
                                <div>
                                    <img src={Logo} alt="Logo Icyteg" style={{ width: "55px", margin: "15px" }} />
                                    <br />
                                    <p style={{ fontSize: "14pt" }}>
                                        Ocurrio un error al enviar los datos.
                                    </p>
                                    <p style={{ fontSize: "12pt" }}>
                                        Por favor vuelva a intentarlo o puede contactarnos por los siguientes medios.
                                    </p>
                                    
                                    <ul style={{ width: "390px", margin: "auto" }}>
                                        
                                        <li>
                                            Tel&eacute;fono: (462)6271789
                                            </li>
                                        <li>
                                            WhatsApp: +52 (462) 2336965
                                            <MobileView>
                                                <p>
                                                    <a href='https://wa.me/524622336965' target="_blank"><img src={LogoWhatsApp} alt='llamar WhatsApp' style={{ width: "30px" }} /> Enviar mensaje ahora</a>
                                                </p>
                                            </MobileView>
                                        </li>
                                        <li>
                                            <p>Facebook:<a href='https://www.facebook.com/icyteg.ac' target='_blank'> https://www.facebook.com/icyteg.ac</a></p>
                                        </li>
                                    </ul>


                                </div>
                                :
                                null}

                            {this.state.Mensaje === 5 ?
                                <video title="Proyecto 2020" controls="true" style={{ width: "80%" }}>
                                    {isMobile ?
                                        <source type='video/3gp' src={P2020M} />
                                        :
                                        <source type='video/mp4' src={P2020} />
                                        }
                                </video>
                                :
                                null}

                            {this.state.Mensaje === 6 ?
                                <video title="Modelo Educativo" controls="true" style={{ width: "80%" }}>
                                    {isMobile ?
                                        <source type='video/3gp' src={ModeloM} />
                                        :
                                        <source type='video/mp4' src={Modelo} />
                                    }
                                </video>
                                :
                                null}

                            {this.state.Mensaje === 7 ?
                                <div className="Titulacion" style={{ overflowY: "scroll", height: "85%" }}>
                                    <div>
                                        <h3>Los egresados de nuestros programas educativos en l&iacute;nea podr&aacute;n titularse, por medio de alguna de las siguientes opciones:</h3>
                                        <br/>
                                        <br />
                                    </div>
                                    <strong>Nivel Lienciatura</strong>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <strong>Cr&eacute;ditos de Postgrado. </strong><span> Se acredita cursando el 50% de cr&eacute;ditos de un postgrado de nivel superior. Ejemplo: para titularse de maestr&iacute;a, se debe cursar el 50% de cr&eacute;ditos de uno de nuestros doctorados. </span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Desarrollo de una empresa. </strong><span> Elaboraci&oacute;n de un proyecto para el establecimiento de una empresa en un &aacute;rea af&iacute;n al programa de estudios.</span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Desarrollo de productos de utilidad. </strong><span> Realizaci&oacute;n de un producto (libro, recurso did&aacute;ctico, nuevas tecnolog&iacute;as, etc.) af&iacute;n al programa de estudios.</span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Proyecto de Intervenci&oacute;n Educativa. </strong><span> El alumno integrar&aacute; un proyecto de intervenci&oacute;n educativa.</span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Tesis </strong><span>Elaboraci&oacute;n de un proyecto de Tesis </span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Tesis Grupal</strong><span>Elaboraci&oacute;n de un proyecto de Tesis (2 a 3 alumnos egresados) </span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Titulaci&oacute;n por art&iacute;culo en revista arbitrada. </strong><span> Se acredita con la publicaci&oacute;n de dos art&iacute;culos en una revista arbitrada.</span>
                                            <br/>
                                        </li>
                                        <li>
                                            <strong>Seminario de Titulación. </strong>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Examen de conocimiento por áreas. </strong>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Examen de conocimiento por áreas. </strong>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Excelencia académica. </strong>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Reporte de Investigación</strong>
                                            <br />
                                        </li>
                                        
                                    </ul>
                                    <strong>Nivel Maestría</strong>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <strong>Cr&eacute;ditos de Postgrado. </strong><span> Se acredita cursando el 50% de cr&eacute;ditos de un postgrado de nivel superior. Ejemplo: para titularse de maestr&iacute;a, se debe cursar el 50% de cr&eacute;ditos de uno de nuestros doctorados. </span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Desarrollo de una empresa. </strong><span> Elaboraci&oacute;n de un proyecto para el establecimiento de una empresa en un &aacute;rea af&iacute;n al programa de estudios.</span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Desarrollo de productos de utilidad. </strong><span> Realizaci&oacute;n de un producto (libro, recurso did&aacute;ctico, nuevas tecnolog&iacute;as, etc.) af&iacute;n al programa de estudios.</span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Proyecto de Intervenci&oacute;n Educativa. </strong><span> El alumno integrar&aacute; un proyecto de intervenci&oacute;n educativa.</span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Tesis </strong><span>Elaboraci&oacute;n de un proyecto de Tesis </span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Tesis Grupal</strong><span>Elaboraci&oacute;n de un proyecto de Tesis (2 a 3 alumnos egresados) </span>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Titulaci&oacute;n por art&iacute;culo en revista arbitrada. </strong><span> Se acredita con la publicaci&oacute;n de dos art&iacute;culos en una revista arbitrada.</span>
                                            <br />
                                        </li>

                                    </ul>
                                    <strong>Nivel Doctorado</strong>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <strong>Programa de Investigación Doctoral </strong>
                                            <br />
                                        </li>
                                        <li>
                                            <strong>Tesis </strong><span>Elaboraci&oacute;n de un proyecto de Tesis </span>
                                            <br />
                                        </li>

                                        <li>
                                            <strong>Titulaci&oacute;n por art&iacute;culo en revista arbitrada. </strong><span> Se acredita con la publicaci&oacute;n de dos art&iacute;culos en una revista arbitrada.</span>
                                            <br />
                                        </li>

                                    </ul>
                                </div>
                                :
                                null}

                            {this.state.Mensaje === 8 ?
                                <div className="Titulacion" style={{ overflowY: "scroll", height: "85%" }}>
                                    <div>
                                        <h3>Nuevos programas educativos</h3>
                                        <br />
                                        <br />
                                        <h4>Doctorados:</h4>
                                    <br/>
                                    </div>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <a href='/Doctorado/Educacion_y_Ambientes_de_Aprendizaje_Digital'><strong>DOCTORADO EN EDUCACION Y AMBIENTES DE APRENDIZAJE DIGITAL</strong></a>
                                        </li>
                                        <li>
                                            <a href='/Doctorado/Educacion_Especial'><strong>DOCTORADO EN CIENCIAS DE LA EDUCACI&Oacute;N ESPECIAL EN INCLUSI&Oacute;N Y BARRERAS DE APRENDIZAJE</strong></a>
                                        </li>
                                    </ul>
                                    <br/>
                                    <h4>Maestr&iacute;as:</h4>
                                    <br/>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <a href='/Maestria/Educacion_Nutricional'><strong>MAESTR&iacute;A EN CIENCIAS DE LA EDUCACI&Oacute;N NUTRICIONAL</strong></a>
                                        </li>
                                        <li>
                                            <a href='/Maestria/Educacion_y_Nuevas_Tecnologias'><strong>MAESTR&iacute;A EN EDUCACI&Oacute;N Y NUEVAS TECNOLOG&Iacute;AS</strong></a>
                                        </li>
                                    </ul>
                                    <br/>
                                    <h4>Diplomados:</h4>
                                    <br/>
                                    <ul style={{ listStyleType: "lower-alpha" }}>
                                        <li>
                                            <a href='/Diplomados/TDAH'><strong>DIPLOMADO EN INCLUSI&Oacute;N EN EL AULA DE NIÑOS CON TDAH</strong></a>
                                        </li>
                                        <li>
                                            <a href='/Diplomados/Autismo'><strong>DIPLOMADO EN INCLUSI&Oacute;N EN EL AULA DE NIÑOS CON AUTISMO</strong></a>
                                        </li>
                                        <li>
                                            <a href='/Diplomados/Aplicaciones_Google'><strong>USO DID&Aacute;CTICO EN EL AULA DE LAS APLICACIONES GOOGLE</strong></a>
                                        </li>
                                       

                                    </ul>

                                </div>
                                :
                                null}

                            {this.state.Mensaje === 9 ?
                                <div style={{ overflowY: "scroll", height: "85%" }}>
                                    <h2>AVISO DE PRIVACIDAD </h2>
                                    <br/>
                                    <p>
                                            El Instituto de Ciencias Humanidades Y Tecnologías de Guanajuato, con domicilio en Francisco Sarabia #189, col. Moderna, C.P. 36690 Irapuato, Guanajuato, México, es responsable de recabar los datos personales de los alumnos inscritos y aspirantes a sus programas académicos, con el único propósito de brindar los servicios educativos y mantener comunicación con sus alumnos y aspirantes para dichos fines, así mismo el Instituto declara que sólo compartirá dicha información con terceros relacionados con el servicio que presta, así mismo  protegerá de acuerdo a la normatividad vigente dicha información. 
                                        </p>
                                    <p>
                                            La información personal del alumno y los aspirantes que se registren en la página serán utilizados para proveer los servicios que ha solicitado, brindar información relativa a su estatus como alumno o aspirante, a los servicios contratados y a informarle de cambios en los mismos, así como evaluar la calidad de servicio que le ofrecemos. Para las finalidades antes mencionadas podemos recabar sus datos personales de distintas formas: cuando usted nos los proporciona directamente; cuando recomienda a un amigo para recibir información; cuando visita el sitio http://www.icyteg.edu.mx.
                                                                                </p>
                                    <p>
    
                                        Para ello recabamos sus datos personales cuando usted mismo nos lo proporciona por diversos medios, los datos personales obtenidos son: nombre, dirección, teléfono, sexo, fecha de nacimiento, lugar de nacimiento, CURP, correo electrónico, Id de Skype, twiter, Facebook. 
                                                                                </p>
                                    <p>
    
                                        De la misma manera se señala que nuestros portales http://www.icyteg.com.mx , http://www.icyteg.edu.mx tienen como finalidad la promoción de nuestros programas académicos y cualquier persona sea o no un alumno puede navegar en ellos. Dichos portales cuentan con acceso a un boletín informativo que se distribuye por medio de correo electrónico al cual los usuarios del sitio podrán subscribirse y cancelar dicha subscripción en cualquier momento proporcionando únicamente su correo electrónico. 
                                                                                </p>
                                    <p>
    
                                        Usted tiene derecho de acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación contractual o de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos. 
                                                                                </p>
                                    <p>
    
                                        Para conocer dichos procedimientos, los requisitos y plazos, se puede poner en contacto con nuestra Coordinación de Informática y Estadística en Francisco Sarabia #189, Col. Moderna C.P. 36690, Irapuato, Guanajuato, México, así como a los teléfonos: (462)6258898, (462)6258897, (462)6255712, (462)6255713. También nos puede contactar enviando un correo a informes@icyteg.edu.mx o visitar nuestra página de Internet www.icyteg.edu.mx 
                                        </p>
                                    <p>
                                            Al utilizar nuestros servicios o visitar nuestra página, acepta  las condiciones del presente aviso. La transferencia de información a terceros sólo se dará con los organismos  gubernamentales e instituciones financieras relacionadas con el servicio que prestamos, y  salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, así como a realizar esta transferencia en los términos que fija esa ley.
                                        </p>




                                    
                                        </div>
                                :
                                null}

                            {this.state.Mensaje === 10 ?
                                <div style={{ padding: "15px", textAlign: "justify"}}>

                                    
                                    
                                        <p>COMUNICADO ICYTEG referente al COVID19<br />
                                        23 de noviembre de 2020<br />
                                            A toda la comunidad de  estudiantes y profesores,<br />
                                            <br />
                                                    Ante la propagación a nivel  internacional del coronavirus Covid-19, el compromiso del ICYTEG es velar por  la salud y seguridad de todos en nuestra comunidad. La epidemia del Covid-19 es  una realidad global que no podemos ignorar. Hemos venido observando con  atención, detalle y rigor los comunicados oficiales de las autoridades competentes  de México y las recomendaciones de la OMS respecto de la evolución de esta  enfermedad.</p>
                                        <p>En vista de todo ello, de que los niveles en los estados a bajado y son pocos los estados en alerta roja, de manera  preventiva y buscando contribuir a aminorar, retardar y minimizar la escalada  del contagio, hemos tomado las siguientes determinaciones:<br />
                                            <ul>
                                                <li><p>Todas las clases presenciales  serán impartidas por medios tecnológicos, utilizando nuestra plataforma de aula  virtual. No se impartirá ninguna clase de forma presencial. <br />
                                                            Las clases en línea no sufren  alteración de horarios y el servicio educativo permanecerá igual.</p></li>
                                                <li><p>El ciclo escolar actual será finalizado através de educación en línea, esperaremos las indicaciones de las autoridades educativas para el inicio del próximo ciclo escolar.</p></li>
                                                <li> <p>
                                                    Nuestros diferentes planteles  y oficinas de atención serán cerradas, para evitar el contacto directo; el  personal de ICYTEG seguirá laborando desde sus domicilios y brindaremos los  servicios a través de correo electrónico en los siguientes correos: <br />
                                                                Control Escolar <a href="mailto:controlescolar@icyteg.edu.mx">controlescolar@icyteg.edu.mx</a><br />
                                                                    Cuentas por cobrar <a href="mailto:cuentasporcobrar@icyteg.edu.mx">cuentasporcobrar@icyteg.edu.mx</a><br />
                                                                        Soporte técnico <a href="mailto:soporte@icyteg.edu.mx">soporte@icyteg.edu.mx</a><br />
                                                                            Dirección general <a href="mailto:dg@icyteg.edu.mx">dg@icyteg.edu.mx</a></p></li>

                                            </ul>


                                            <p>
                                                Atentamente</p>
                                            <p>Dirección General</p> </p>  
	</div>
                                :
                                null}
                        </div>
                    </div>
                    :
                    <div></div>
                }

               
            </div>
        )
    }
}
export default PopUp;


// WEBPACK FOOTER //
// ./src/components/PopUp.js